import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

import { LoaderBars } from './LoaderBars';
import { LoaderDots } from './LoaderDots';
import { LoaderLogo } from './LoaderLogo';
import { LoaderSpinner } from './LoaderSpinner';

export type LoaderType = 'bars' | 'dots' | 'spinner' | 'logo';
export type LoaderExpand = 'fullscreen' | 'cover';

export type LoaderProps = {
  type?: LoaderType;
  expand?: LoaderExpand;
  className?: string;
  name?: string;
};

/*
  The spinner is kept out and rendered on its own below, because `fullscreen` is its prop alone. A
  record typed to hand every loader that prop said otherwise, and left a reader no way to tell
  which of the four it actually reached.
*/
const LOADER_TYPE_COMPONENTS: Record<
  Exclude<LoaderType, 'spinner'>,
  React.ComponentType
> = {
  bars: LoaderBars,
  dots: LoaderDots,
  logo: LoaderLogo,
};

export const Loader = ({
  type = 'spinner',
  expand,
  className,
  name,
}: LoaderProps) => {
  const combinedClassName = AttrsHelper.formatClassname(
    'axiom-loader',
    expand ? `expand-${expand}` : 'expand-none',
    className
  );

  return (
    <div className={combinedClassName} data-test={name}>
      {type === 'spinner' ? (
        <LoaderSpinner fullscreen={!!expand} />
      ) : (
        React.createElement(LOADER_TYPE_COMPONENTS[type])
      )}
    </div>
  );
};
